export default __webpack_public_path__ + "static/media/624.70710cc9.jpg";